import $ from 'jquery'
import _ from 'underscore'
import BasicLightbox from '../../BasicLightbox'
import {escapeHtmlSymbols, isNotEmpty} from '../../atUtils'
import {isOlVersion} from 'constants'
import messageResource from '../../messageResource'
import {onKeyDown, isEsc} from '../../keyHandlers/index'

function UserDataLightBox() {}

UserDataLightBox.prototype = new BasicLightbox();

UserDataLightBox.prototype.exist_invalid_fields_message_key = "user.add_edit.js.footer_error.exist_invalid_fields";

UserDataLightBox.prototype.init = function( sectionsBuilder, userManagementData, userId, accountSettings, showOvertime, otherProductStatusEditable)
{
    BasicLightbox.prototype.init.call( this, "userDataLightBox", "closeUserDataLightBoxBtn" );

    this._sectionsBuilder = sectionsBuilder;
    this.userManagementData = userManagementData;

    var self = this;

    this.dataChanged = false;
    this._changesCallback = function( notRequireConfirmationOnCopySettings ) {
        if( !self.dataChanged )
            self.changesDetected();
        self.dataChanged = true;
        if ( !notRequireConfirmationOnCopySettings && self.setNeedToConfirmWhenCopySettings )
            self.setNeedToConfirmWhenCopySettings( true );
    };

    this._forceCancelCallback = function()
    {
        self.dataChanged = false;
        self.cancel();
    };

    this.accountSettings = accountSettings;

    //noinspection JSUnusedLocalSymbols
    var hideBoxBeforeReloadErrorHandler = function ( jqXHR, textStatus, errorThrown )
    {

        if( textStatus == "rpc_sessionExpired" || textStatus == "rpc_noRights" )
        {
            //hide window to prevent confirmation dialog
            self.hide();
        }

        return false; // pass flow to default jquery error handler
    };

    var checkLightBoxIsShown = function()
    {
        return self.isShowed;
    };

    $(this.lightBoxEl ).addClass(isOlVersion ? "online" : "downloadable");
    $( this.lightBoxEl ).removeClass("createMode");

    this._orderedSectionsList = this._sectionsBuilder.createSections(
        this._changesCallback,
        this._validateCallback,
        this.lightBoxEl,
        hideBoxBeforeReloadErrorHandler,
        this._makeSetUpNameCallBack(),
        this.handlerIfNoSuchUserAfterAjax,
        showOvertime,
        otherProductStatusEditable,
    )

    this._sectionsErrorsHandler = this._sectionsBuilder.getSectionsErrorsHandler();
    this._userInputDataFetcher = this._sectionsBuilder.getUserInputDataFetcher();

    this.titlePlaceholder = document.getElementById( this.lightBoxEl.id + "_titlePlaceholder" );
    this.userNamePlaceholder = document.getElementById( this.lightBoxEl.id + "_userNamePlaceholder" );
    this.commitButtonTitlePlaceholder = $( document.getElementById( this.lightBoxEl.id + "_commitBtn" ) ).find(".buttonTitle");

    this.deleteButton = document.getElementById( this.lightBoxEl.id + "_deleteBtn" );

    this.userId = userId;
    this.defaultWorkSchedule = userManagementData.defaultWorkSchedule;

    return this;
};

UserDataLightBox.prototype.cancelAllServerSideChecks = function (){
    for( var i = 0; i < this._orderedSectionsList.length; i++ )
    {
        var section = this._orderedSectionsList[i];
        section.cancelAllServerSideChecks();
    }
};

UserDataLightBox.prototype.handleSectionError = function( resultCode, errorParams )
{
    var self = this;
    this._sectionsErrorsHandler.handleError( resultCode, function ( section ) { self.scrollToSection($( section.getSectionElement() )); }, errorParams );
    if (this.hasErrors())
    {
        this.printErrorInFooter(messageResource.getMessage(this.exist_invalid_fields_message_key));
        this._blinkErrorInFooter();
    }
};

UserDataLightBox.prototype.handleDuplicateTimeZoneError = function(timeZoneGroups)
{
    this.handleSectionError(this._sectionsErrorsHandler.DUPLICATE_TIME_ZONE_GROUP_ERROR, timeZoneGroups);
};

UserDataLightBox.prototype.updateUI = function ()
{
    for( var i = 0; i < this._orderedSectionsList.length; i++ )
    {
        this._orderedSectionsList[i].updateUI();
    }
};

UserDataLightBox.prototype.validateAll = function ( scrollToInvalidSection )
{
    var invalidSection;
    var valid = true;
    for( var i = 0; i < this._orderedSectionsList.length; i++ )
    {
        var section = this._orderedSectionsList[i];
        if( !section.validate() )
        {
            valid = false;
            if( !invalidSection )
            {
                invalidSection = section;
            }
        }
    }
    this._validateCallback();
    if( scrollToInvalidSection && invalidSection )
    {
        this.scrollToSection( $( invalidSection.getSectionElement() ) );
    }
    return valid;
};

UserDataLightBox.prototype.validate = function ()
{
    return this.validateAll(true);
};

UserDataLightBox.prototype.scrollToTop = function()
{
    this.setScrollPosition( 0 );
};

UserDataLightBox.prototype.getScrollPosition = function()
{
    return $('#' + this.lightBoxEl.id + ' .innerContent').scrollTop();
};

UserDataLightBox.prototype.setScrollPosition = function( scrollTop )
{
    $('#' + this.lightBoxEl.id + ' .innerContent').scrollTop( scrollTop );
};

UserDataLightBox.prototype.hasErrors = function()
{
    for( var i = 0; i < this._orderedSectionsList.length; i++ )
        if( this._orderedSectionsList[i].hasErrors() )
            return true;
    return false;
};

UserDataLightBox.prototype.getDataToCommit = function()
{
    return this._userInputDataFetcher.getUserInputData( this.userManagementData );
};

UserDataLightBox.prototype.setTitle = function( title )
{
    this.titlePlaceholder.innerHTML = escapeHtmlSymbols( title );
};

UserDataLightBox.prototype.setNameInTitle = function( name )
{
    this.userNamePlaceholder.innerHTML = escapeHtmlSymbols( name );
};

UserDataLightBox.prototype._makeSetUpNameCallBack = function()
{
   var self = this;

    return function( firstName, lastName, middleName )
    {

        var name = self.formatUserName( firstName, lastName, middleName );
        self.setTitle( messageResource.getMessage("user.add.js.new") + (name.length > 0 ? ": " : "") );
        self.setNameInTitle( name );
    }
};

UserDataLightBox.prototype.formatUserName = function( firstName, lastName, middleName )
{
    var result = "";

    var lastNameNoEmpty = isNotEmpty( lastName );
    if( lastNameNoEmpty )
        result += lastName;

    if( isNotEmpty( firstName ) )
    {
        if( lastNameNoEmpty )
            result += ", ";
        result += firstName;
    }

    if( result.length > 0 && !_.isNull( middleName ) && isNotEmpty( middleName ) )
        result += " " + middleName + ".";

    return result;
};

UserDataLightBox.prototype.restoreOnKeyDownHandler = function() {
    if (this.removeHandler) this.removeHandler()
}

UserDataLightBox.prototype.setupKeyDownHandler = function() {
    this.removeHandler = onKeyDown((code) => {
        if (isEsc(code)) {
            this.cancel()
            return true
        }
    })
}

export default UserDataLightBox



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/UserDataLightBox.js